import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CoinCalculator from "./CoinCalculator";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CoinCalculator />
    </QueryClientProvider>
  );
}
